import type { MarkElementTypesReviewedInPlan } from "./types";

export const markElementTypesReviewedInPlan: MarkElementTypesReviewedInPlan = ({
  plan,
  elementTypeIds,
}) => {
  if (elementTypeIds.length === 0) return plan;
  const targetIds = new Set(elementTypeIds);

  let didFlip = false;
  const nextGroupMeta: typeof plan.groupMeta = {};
  for (const [groupLabel, meta] of Object.entries(plan.groupMeta)) {
    if (
      targetIds.has(meta.element_type_id) &&
      meta.nameStatus === "suspicious"
    ) {
      nextGroupMeta[groupLabel] = { ...meta, nameStatus: "confident" };
      didFlip = true;
    } else {
      nextGroupMeta[groupLabel] = meta;
    }
  }

  if (!didFlip) return plan;
  return { ...plan, groupMeta: nextGroupMeta };
};
